import { useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { userState } from "../states/userState";
import { InitialParameters, User } from "../types/index";
import { setUserToLocalStorage } from "../utils/functions/localStorageManager";
import { loadingState, loadingText } from "../states/loadingState";
import { sleep } from "../utils/functions/commons";
import { auth, provider } from "../firebase";
import { signInWithPopup } from "firebase/auth";
import { useMediaQuery, useTheme } from "@mui/material";

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [user, setUser] = useRecoilState(userState);
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isIphone = useMediaQuery(theme.breakpoints.down("sm"));
  const login = async () => {
    setLoading(true);
    setLoadingAnimation(true);
    setLoadingText("ログイン中...");
    //Google認証を実行
    const result = await signInWithGoogle();
    if (!result) return 1;
    //Recoilにユーザ情報をセット
    const googleUser = result.user;
    const photoURL = googleUser.photoURL ?? "";
    const displayName = googleUser.displayName ?? "";
    const email = googleUser.email ?? "";

    setUser((prevUser: User) => {
      // const newUser: User = { ...prevUser, isAuth: true };
      // デフォルト値を設定
      const defaultInitialParams: InitialParameters = {
        workerSingleForInput: null,
        workersForMultiInput: [],
        workersForList: [],
        factoryNo: [51],
        factoryNoForSingleInput: 51,
        factoryNoForMultiInput: 51,
        productNo: "",
        productBno: "",
        productNoForSingleInput: "",
        productBnoForSingleInput: "",
        productNoForMultiInput: "",
        productBnoForMultiInput: "",
        latestUrl: "/",
        // construction: 5,
        // constructionForSingleInput: 5,
        // constructionForMultiInput: 5,
        slipNumberForSingleInput: "0000000",
        slipNumberForMultiInput: "0000000",
        isShowSlipNumber: false,
        productNoForMatrix: "",
        productBnoForMatrix: "",
        // constructionForMatrix: 5,
        wokerIdForMatrix: "",
        factoryNoForMatrix: 51,
        isPinned: true,
        zoomLevel: isMobile || isIphone ? "0.75" : "1",
      };
      const newUser: User = {
        ...prevUser,
        mail: email, //メールアドレス
        photoURL: photoURL, //写真URL
        workerName: displayName, //社員名
        isAuth: true,
        initialParameters: {
          ...prevUser.initialParameters,
          ...defaultInitialParams,
          factoryNo: [51],
        },
      };
      //LocalStorageにユーザ情報をセット
      setUserToLocalStorage(newUser);
      return newUser;
    });

    setLoadingAnimation(false);
    setLoadingText("");
    setLoading(false);
    return 0;
  };

  return { login, loading, error };
};

const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider); // Google認証を試みる
    return result; // 認証が成功した場合はtrueを返す
  } catch (error: any) {
    alert(error.message); // エラーメッセージを表示
    return false; // 認証が失敗した場合はfalseを返す
  }
};
